<template>
  <div class="col left-navbar-container d-none d-sm-block">
    <div class="left-navbar pt-5 d-flex flex-column justify-content-between">
      <ul>
        <li id="recharge" :class="{ active: isRecharge }">
          <router-link :to="{ name: 'recharge'}" class="icon-container">
            <i class="material-icons">attach_money</i>
            <p class="d-none d-sm-inline"> Recharge</p>
          </router-link>
        </li>
        <li id="rechargeOffer" :class="{ active: isRechargeOffer }">
          <router-link :to="{ name: 'rechargeOffer'}" class="icon-container">
            <i class="material-icons">local_offer</i>
            <p class="d-none d-sm-inline"> Recharge WO</p>
          </router-link>
        </li>
      </ul>
      <ul>
        <li id="logout">
          <router-link :to="{ name: 'logout'}" class="icon-container">
            <i class="material-icons">power_settings_new</i>
            <p class="d-none d-sm-inline"> Logout</p>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WebContentLeftNav',
  mounted () {
    this.isRecharge = this.$route.name === 'recharge'
    this.isRechargeOffer = this.$route.name === 'rechargeOffer'
  },
  data () {
    return {
      isRecharge: false,
      isRechargeOffer: false
    }
  }
}
</script>

<style lang="scss" scoped>
.left-navbar-container {
  min-height: calc(100vh - 60px);
  padding: 0;
  max-width: 200px;
}

.left-navbar {
  position: fixed;
  width: 200px;
  background-color: rgb(65, 72, 81);
  color: rgb(255, 255, 255);
  height: calc(100vh - 60px);

  ul {
    padding: 0;

    &.push-bottom {
      position: absolute;
      bottom: 0;
    }

    li {
      list-style: none;

      &:hover {
        background-color: rgb(106, 111, 118);
      }

      a {
        color: #FFFFFF;
        padding: 30px;
        display: block;
        width: 100%;
        height: 100%;

        &:hover {
          text-decoration: none;
        }
      }

      &.active {
        background-color: rgb(106, 111, 118);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/WebContentLeftNav.vue